import UserComponent from 'components/userComponent';
import React from 'react';
import { IMemberProfilesProps } from './IMemberProfilesProps';
import './MemberProfiles.scss';

const MemberProfiles: React.FC<IMemberProfilesProps> = (props) => {
  const maxDisplayed = props.maxDisplayed || 4;
  return (
    <div className="member-profiles-container">
        <ul className="member-profiles-wrapper">
            {
            props.memberProfiles.map((member: any, index: any) => (
                member && index < maxDisplayed && (
                <li key={index} >
                    <UserComponent key={index}
                    hideAdmin={true}
                    user={member}
                    hideName={true}
                    profilePicture={member.profile_image}
                    disabled={props.disabled}
                    />
                </li>
                )
            ))
            }
            {props.memberCount ? <li className="plus-members"> {props.memberCount} </li> : <></>}
        </ul>
    </div>
  )
}

export default MemberProfiles;